export default {
  header: {
    notes: 'Header of error message',
    message: 'Oops! Something went wrong.',
  },
  newVersion: {
    header: {
      notes: 'Header of dialog for newly deployed version',
      message: 'New version exists',
    },
    dialogContent: {
      notes: 'Content of dialog for newly deployed version',
      message:
        'A new version of the application exists. Click the button below to reload the application and start using the new version!',
    },
    reloadButton: {
      notes: 'Button title for reload button',
      message: 'Reload',
    },
  },
};
